<template>
  <div v-if="!isShow">
    <!-- 占位空间 -->
    <div class="block"></div>
    <div class="openapp">
      <img class="openapp__icon" src="@/assets/img/base/gkztc_logo_big.png" />

      <div class="openapp__btn" @click="openApp">
        App内查看
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'openApp',
  data() {
    return {
      isShow: true
    }
  },
  created() {
    const ua = navigator.userAgent.toLowerCase()
    // 小程序和app都不显示
    if (ua.indexOf('gkztc') === -1 && ua.indexOf("miniprogram") === -1) {
      this.isShow = false
    }
  },
  methods: {
    openApp() {
      const link = 'gkztc://browser/' + document.getElementById("shareurl").content
      location.href = link
      setTimeout(() => {
        location.href = "https://app.gaokaozhitongche.com/d";
      },2000)
    },
  }
}
</script>

<style lang="scss" scoped>
.openapp {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  width: 100%;
  height: 3rem;
  background: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0.7rem;
  border-bottom: 0.05rem solid #F5F5F5;
  z-index: 2;
  &__icon {
    height: 2rem;
    width: auto;
    
  }

  &__btn {
    font-size: 0.6rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    padding: 0 0.4rem;
    height: 1.5rem;
    background: linear-gradient(270deg, #6BA9FF 0%, #2382FF 100%);
    border-radius: 0.75rem;
    display: flex;
    align-items: center;
  }
}

.block {
  width: 100%;
  height: 3rem;
  background: #FFFFFF;
}
</style>